<template>
  <component
    ref="form"
    :is="config.name"
    :showMobile="showMobile"
    :mode="mode"
    v-model="_value"
    :perm="config.perm || perm"
    :formData="formData"
    :forms="forms"
    v-bind="config.props"
    :key="config.name"/>
</template>
<script>

import components from '@/components/approval/common/form/ComponentExport'
 export default {
  name: 'FormDesignRender',
  components: components,
  props: {
    showMobile: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'DESIGN'
    },
    value: {
      default: undefined
    },
    config: {
      type: Object,
      default: () => {
        return {}
      }
    },
    formData: {
      type: [ Object, Array ],
      default: () => ({})
    },
    forms: {
      type: Array,
      default: () => ([])
    },
    perm: {
      type: String,
      default: ''
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    validate(call) {
      // 如果内部组件不存在或没有 validate 方法，直接返回 true
      if (!this.$refs.form || typeof this.$refs.form.validate !== 'function') {
        call && call(true)
        return
      }

      try {
        this.$refs.form.validate(call)
      } catch (error) {
        console.error('FormDesignRender validate error:', error)
        // 出错时返回 true，避免阻塞整个校验流程
        call && call(true)
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
